import { Subject } from 'rxjs';

const subject = new Subject();

export const editTopicService = {
  emitReload: val => subject.next(val),
  reload: () => subject.asObservable()
};